var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"mode":"out-in","name":"fade"}},[_c('div',{staticClass:"m-3"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }